import { Button, CircularProgress, Typography } from "@mui/material";
import { useNavigate } from "react-router";
import { formatTurkishToEnglishString } from "../../helpers/TodayDate";
import { useContext, useState } from "react";
import { ThemeContext } from "../../context/themeProviderContext";

const MainCard = (props: any) => {
  const navigate = useNavigate();
  const { fontSize }: any = useContext(ThemeContext);
  const [loading, setLoading] = useState(false);
  function delayAndExecute(callback: () => void, delayMs: number = 4000): void {
    setTimeout(() => {
      callback();
    }, delayMs);
  }
  const handleCardClick = async () => {
    if (props.sayfaLink.startsWith("http")) {
      if (props.sqId === 2) {
        setLoading(true);
        delayAndExecute(() => {
          setLoading(false); // İstersen bunu da kaldırabilirsin çünkü zaten yönlendiriliyor
          window.location.href = props.sayfaLink;
        });
      } else {
        window.location.href = props.sayfaLink;
      }
    } else {
      navigate(props.sayfaLink);
    }
  };
  
  if(loading){
    return <div style={{backgroundColor:"#ffffff",height:"100%",zIndex:"1000",position:"absolute",top:0,left:0,right:0,bottom:0}} className="d-flex w-100 flex-column justify-content-center align-items-center">
      <CircularProgress></CircularProgress>
      <Typography className="mt-3">Ödeme sayfasına yönlendiriliyorsunuz, ekranın yönlendireceği kimlik doğrulama işlemlerini takip etmelisiniz.</Typography>
    </div>
  }
  return (
    <div
      onClick={handleCardClick}
      className="col-xxl-2 col-xl-3 col-lg-3 col-md-4 col-sm-6 box-col-12 p-2"
      style={{
        backgroundColor: "var(--mainBackgroundColor)",
        cursor: "pointer",
      }}
    >
      <div
        style={{
          backgroundImage: `url(${process.env.PUBLIC_URL}/profile-bg.png)`,
          minHeight: "340px",
        }}
        className="w-100 px-3 py-4 rounded-4 container justify-content-center align-items-center bg-picture-card"
      >
        <Button
          style={{ fontSize: `${fontSize}rem` }}
          className="w-100 text-white mb-2"
        >
          {props.title}
        </Button>
        <div className="w-100">
          <img src={props.iconPath} alt="icon" />
        </div>
      </div>
    </div>
  );
};

export default MainCard;
